import React, { useState } from "react";
import css from "components/mobile/meeting/calendar/calendar.module.css";
import { ReactComponent as WeekIcon } from "asset/calendar/week.svg";
import { Button, ConfigProvider, DatePicker, Popover, Radio } from "antd";
import {
  LeftOutlined,
  RightOutlined,
  SwapRightOutlined,
  TableOutlined,
} from "@ant-design/icons";

/**
 * 파일명: header.js
 * 작성자: 권도훈
 * 작성일자: 25.02.24
 * 설명: 모바일 페이지 캘린더 헤더
 */
function Header({
  date,
  view,
  viewList,
  monthView,
  onChangeView,
  onPrev,
  onNext,
  onChangeDate,
  onReserveNow,
}) {
  const [popOver, setPopOver] = useState(false);

  return (
    <section className={css.header}>
      <DateIndicator
        date={date}
        onPrev={onPrev}
        onNext={onNext}
        onChangeDate={onChangeDate}
      />

      <section className={css.header_btn_area}>
        <ConfigProvider
          theme={{
            components: {
              Button: {
                defaultBg: "#fff",
                defaultBorderColor: "#b4b4b4",
                defaultHoverBg: "#fff",
                defaultHoverBorderColor: "#b4b4b4",
                defaultActiveBg: "#fff",
                defaultActiveBorderColor: "#b4b4b4",
                primaryShadow: "0",
              },
            },
          }}
        >
          <Popover
            trigger="click"
            arrow={false}
            placement="bottom"
            open={popOver}
            onOpenChange={(res) => setPopOver(res)}
            content={
              <Radio.Group
                className={css.popover}
                value={view}
                options={viewList.map((item) => {
                  return {
                    value: item,
                    label: (
                      <div
                        className={
                          item === view
                            ? `${css.popover_content} ${css.selected}`
                            : css.popover_content
                        }
                      >
                        {item === monthView ? <TableOutlined /> : <WeekIcon />}
                        <p>{item === monthView ? "월" : "주"}</p>
                      </div>
                    ),
                  };
                })}
                onChange={(e) => {
                  if (e.target.value !== view) {
                    onChangeView();
                  }
                  setPopOver(false);
                }}
              />
            }
          >
            <Button
              className={`${css.header_btn} ${css.type}`}
              // onClick={() => onChangeView()}
              icon={view === monthView ? <TableOutlined /> : <WeekIcon />}
            />
          </Popover>
        </ConfigProvider>

        <ConfigProvider
          theme={{
            components: {
              Button: {
                defaultBg: "#1cb691",
                defaultColor: "#fff",
                defaultBorderColor: "#1cb691",
                defaultHoverBg: "#1cb691",
                defaultHoverColor: "#fff",
                defaultHoverBorderColor: "#1cb691",
                defaultActiveBg: "#1cb691",
                defaultActiveColor: "#fff",
                defaultActiveBorderColor: "#1cb691",
                primaryShadow: "0",
              },
            },
          }}
        >
          <Button
            className={`${css.header_btn} ${css.meeting}`}
            onClick={onReserveNow}
          >
            <p>즉시 미팅</p>
            <SwapRightOutlined />
          </Button>
        </ConfigProvider>
      </section>
    </section>
  );
}

export default Header;

function DateIndicator({ date, onPrev, onNext, onChangeDate }) {
  const type = "month";
  const format = "MMMM YYYY";
  return (
    <section className={css.header_date_area}>
      <LeftOutlined className={css.header_date_btn} onClick={onPrev} />

      <div className={css.date_indicator_area}>
        <label htmlFor="datepicker">
          <div className={css.date_title}>{date.format(format)}</div>
          <ConfigProvider
            theme={{
              token: {
                fontFamily: "Spoqa Han Sans Neo",
              },
              components: {
                DatePicker: {
                  activeShadow: "0",
                  inputFontSize: 18,
                  inputFontSizeLG: 18,
                  inputFontSizeSM: 18,
                },
              },
            }}
          >
            <DatePicker
              className={css.date_indicator}
              popupClassName={css.date_indicator_popup}
              id="datepicker"
              name="datepicker"
              picker={type}
              format={format}
              value={date}
              onChange={onChangeDate}
              superPrevIcon={<LeftOutlined />}
              superNextIcon={<RightOutlined />}
              inputReadOnly
            />
          </ConfigProvider>
        </label>
      </div>

      <RightOutlined className={css.header_date_btn} onClick={onNext} />
    </section>
  );
}
